import { gql } from '@apollo/client';

export const EXIT_INTERVIEW = gql`
  query exit_interview_question($where: exit_interview_question_bool_exp) {
    exit_interview_question(where: $where) {
      id
      isActive
      question
      questionType
      multi_choice_questions {
        id
        exitInterviewQuestionId
        question
      }
      exit_interview_question_group {
        name
        isActive
        id
      }
    }
  }
`;

export const EXIT_INTERVIEW_ANSWER = gql`
  query exit_interview_answer($where: exit_interview_answer_bool_exp) {
    exit_interview_answer(where: $where) {
      id
      questionId
      rateAnswer
      textAnswer
      exit_interview_answer_multi_choice_questions {
        multiChoiceQuestionId
      }
    }
  }
`;
export const STUDENTS_FAMILIARIZATION_FORM = gql`
  query student_familiarization_form($where: student_familiarization_form_bool_exp) {
    student_familiarization_form(where: $where) {
      careerAmbition
      currentResidentLocation
      englishReading
      englishSpeaking
      englishUnderstanding
      englishWriting
      groupOrIndividual
      hometown
      leadOrFollow
      mostComfortableLanguage
      personality
      priorWorkExperience
      schoolsAttended
      skillsToGainFromTheCourse
      timeAtCahmSoFar
      whyChooseHospitality
    }
  }
`;

export const INSERT_EXIT_INTERVIEW_ANSWER = gql`
  mutation insert_exit_interview_answer($objects: [exit_interview_answer_insert_input!]!) {
    insert_exit_interview_answer(objects: $objects) {
      affected_rows
    }
  }
`;

export const INSERT_FAMILIARIZATION_FORM = gql`
  mutation insert_student_familiarization_form($objects: [student_familiarization_form_insert_input!]!) {
    insert_student_familiarization_form(objects: $objects) {
      affected_rows
    }
  }
`;

export const INSERT_STUDENT_PERFORMENCE_FORM = gql`
  mutation insert_student_performance($objects: [student_performance_insert_input!]!) {
    insert_student_performance(objects: $objects) {
      affected_rows
    }
  }
`;

export const INSERT_STUDENT_FAMILIARIZATION_INTERVIEW_FORM = gql`
  mutation insert_student_familiarization_interview($objects: [student_familiarization_interview_insert_input!]!) {
    insert_student_familiarization_interview(objects: $objects) {
      affected_rows
    }
  }
`;

export const STUDENTS_FOR_FAMILIARIZATION_FORM = gql`
  query studentForFamiliarizationForm($where: student_bool_exp!) {
    student(where: $where) {
      regNumber
      dateOfBirth
      firstName
      lastName
      student_batch_histories(where: { endDate: { _is_null: true } }) {
        batch_class {
          name
        }
      }
    }
  }
`;
